import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Paper,
  Tabs,
  Tab,
  Button,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import Counters from '../Counters';
import CustomDialog from '../Dialog/CustomDialog';
import CallStatsDonutChart from '../CallStatsDonutChart';
import EmptyInfiniteListComponent from '../ContactListWrapper/EmptyInfiniteListComponent';

const StatsBox = function StatsBox({
  tabs = [],
  tabValue = 0,
  onChangeTabValue = () => {},
  stats = null,
  heightQuery = false,
  outcomes = [],
}) {
  const intl = useIntl();
  const [graphDialog, setGraphDialog] = useState(false);

  const handleOpenGraph = () => {
    setGraphDialog(true);
  };
  const handleCloseGraph = () => {
    setGraphDialog(false);
  };

  return (
    <>
      <Paper
        square
        sx={{
          height: '50%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
        elevation={3}
      >
        {tabs.length === 1 ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px',
              borderBottom: '1px solid lightgray',
            }}
          >
            <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }} noWrap>
              {intl.messages[tabs[0]] ?? tabs[0]}
            </Typography>
          </div>
        ) : (
          <Tabs
            value={tabValue}
            variant="fullWidth"
            onChange={onChangeTabValue}
          >
            {tabs.map((value) => (
              <Tab key={value} label={intl.messages[value] ?? value} wrapped />
            ))}
          </Tabs>
        )}
        {!stats ? (
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div
            style={{
              display: stats ? 'flex' : 'none',
              flexDirection: 'column',
              overflow: 'hidden',
              gap: '16px',
              padding: '16px',
              height: '100%',
            }}
          >
            {Object.keys(stats)?.length < 1 ? (
              <EmptyInfiniteListComponent />
            ) : (
              <>
                {stats?.counters && <Counters data={stats.counters} />}
                <div
                  style={{
                    display: 'flex',
                    height: '100%',
                    overflow: 'hidden',
                  }}
                >
                  {heightQuery && tabValue !== null ? (
                    <CallStatsDonutChart
                      stats={stats}
                      tabValue={tabs[tabValue]}
                      outcomes={outcomes}
                    />
                  ) : null}
                  {!heightQuery && (
                    <Button
                      onClick={handleOpenGraph}
                      variant="text"
                      fullWidth
                      startIcon={<DonutLargeIcon />}
                      sx={{ color: (theme) => theme.palette.greys.darker }}
                    >
                      {intl.messages.SHOW_DATA}
                    </Button>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </Paper>
      <CustomDialog
        open={graphDialog}
        close={handleCloseGraph}
        title={intl.messages[tabs[tabValue]]}
        maxWidth="sm"
        fullWidth
        showOnly
        disableActions
        styles={{
          root: {
            '.MuiPaper-root': {
              height: '100%',
              minHeight: '400px',
            },
          },
          content: {
            display: 'flex',
            overflow: 'hidden',
          },
        }}
      >
        <CallStatsDonutChart
          stats={tabValue && stats}
          tabValue={tabs[tabValue]}
        />
      </CustomDialog>
    </>
  );
};

StatsBox.propTypes = {
  tabs: PropTypes.array,
  stats: PropTypes.object,
  heightQuery: PropTypes.bool,
  outcomes: PropTypes.array,
  tabValue: PropTypes.number,
  onChangeTabValue: PropTypes.func,
};

export default StatsBox;
